import React, {Component} from 'react';
import { connect } from 'react-redux';
import * as authApi from 'api/auth-api';
import * as actions from 'actions/user-actions';
import store from 'store';
import LoginForm from 'components/views/login-form'
import _ from 'lodash';
import profile from 'config/profile';

const scopes = {"facebook":"email",
    "google":"https://www.googleapis.com/auth/plus.me"};


class LoginFormContainer extends Component {

    enterApp() {
        this.props.router.push('/');
    }

    loginWithSocial(provider) {
        let popupURL = "/social_login_popup.html?";
        const o = {
            authUrl: profile.authUrl,
            scope: scopes[provider],
            provider: provider
        };

        popupURL += Object.keys(o).map(k => {
            return encodeURIComponent(k) + '=' + encodeURIComponent(o[k])
        }).join('&');

        let loginPage = window.open(popupURL,"socialPopupWindow", "width=600, height=400, scrollbars=yes");
        let props = this.props;

        function receiveMessage (e) {
            // For Chrome, the origin property is in the event.originalEvent object.
            var origin = e.origin || e.originalEvent.origin;
            if (o.authUrl.indexOf(origin) < 0) {
                // not from our api server
                return;
            }

            window.removeEventListener('message', receiveMessage);
            loginPage.close();
            // store.dispatch(actions.loginSucceeded());
            props.router.push('/');
        }
        window.addEventListener('message', receiveMessage, false);
    }


    login(event) {
        event.preventDefault();
        const email = this.form.formEl.querySelector('[type=email]').value;
        const password = this.form.formEl.querySelector('[type=password]').value;

        authApi.login(email, password).then((response) => {
            store.dispatch(actions.loginSucceeded());
            store.dispatch(actions.getUserProfileSuccess(response));
            this.props.router.push('/');
        }).catch((error) => {
            if (401 === error.response.status) {
                store.dispatch(actions.loginFailed('Unauthorized', error.response.status));
            } else if (error.message) {
                store.dispatch(actions.loginFailed(error.message));
            } else {
                store.dispatch(actions.loginFailed('An unknown error occurred'));
            }
            return false;
        });
    }

    render() {
        let props = {};
        props.enterApp = this.enterApp.bind(this);
        props.login = this.login.bind(this);
        props.loginWithFacebook = this.loginWithSocial.bind(this, 'facebook');
        props.loginWithGoogle = this.loginWithSocial.bind(this, 'google');
        Object.assign(props, this.props);
        return <LoginForm
            firstName={this.props.firstName}
            lastName={this.props.lastName}
            {...props} ref={(form) => {this.form = form}}/>;
    }
}

const mapStateToProps = function(store) {
    let p = store.userProfile;
    return {
        isLoggedIn: !_.isEmpty(p) && _.isEmpty(p.loginError),
        firstName: p.firstName || '',
        lastName: p.lastName || '',
        loginError: p.loginError
    };
};

export default connect(mapStateToProps)(LoginFormContainer);
